import React, { useCallback, useEffect, useState } from "react";

import { Link } from "react-router-dom";
import ProfileHeader from "../../artistDashboard/Profile/components/ProfileHeader";

import RequestPayoutModal from "../components/RequestPayoutModal";
import { getUserEarningsSummary } from "../../../services/transactionV2";
import TransactionHistory from "./components/TransactionHistory";

import { Tab, Tabs } from "@material-ui/core";
import { TabPanel } from "../../artistDashboard/TabPanel";

import "./index.scss";
import MyBalance from "./components/MyBalance";
import moment from "moment";

function MyMoney() {
  const [totalReported, setTotalReported] = useState(0);
  const [withdrawalAmount, setWithdrawalAmount] = useState(0);
  const [totalWithdrawalAmount, setTotalWithdrawalAmount] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [isPayoutEnabled, setIsPayoutEnabled] = useState(false);
  const [payoutModal, setPayoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupedEarningsArray, setGroupedEarningsArray] = useState([]);

  const [value, setValue] = useState(0);
  const [selectedPeriodId, setSelectedPeriodId] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePeriodClick = (periodId) => {
    setSelectedPeriodId(periodId);
    setValue(1);
  };

  function a11yProps(index) {
    return {
      id: `tab-${index}`,
      "aria-controls": `tabpanel-${index}`,
    };
  }

  const loadSummary = useCallback(() => {
    setLoading(true);
    return getUserEarningsSummary()
      .then(({ data }) => {
        const totals = data?.totals || {};
        const periods = data?.periods || [];

        setTotalReported(totals.totalReported || 0);
        setTotalWithdrawalAmount(totals.totalWithdrawal || 0);
        setWithdrawalAmount(totals.collected || 0);
        setPendingAmount(totals.pending || 0);
        setIsPayoutEnabled((totals.collected || 0) >= 25);

        setGroupedEarningsArray(
          periods.map((p) => ({
            periodId: p.periodId,
            period: p.periodEndDate
              ? moment(p.periodEndDate).format("YYYY-MM")
              : "",
            totalReported: p.totalReported || 0,
            totalCollected: p.totalCollected || 0,
            totalPending: p.totalPending || 0,
            withdrawal: p.withdrawal || 0,
          }))
        );
      })
      .catch((e) => {
        console.error("getUserEarningsSummary", e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  function handleOpenPayoutModal() {
    if (withdrawalAmount >= 25) setPayoutModal(true);
  }

  return (
    <main className="my-earnings">
      <ProfileHeader label="My earnings" />
      <RequestPayoutModal
        modalClassName={payoutModal ? "my-money-payoutModal" : "d-none"}
        overlayClassName={payoutModal ? "" : "d-none"}
        setModal={setPayoutModal}
        userBalance={withdrawalAmount}
        onPayoutSuccess={loadSummary}
      />
      <section className="my-money-section">
        <div className="my-money-section-1-text">
          As soon as we get your cash from streaming services, it will be
          displayed on the{" "}
          <Link to="/artistDashboard/revenue">Revenue page</Link>. Usually, your
          earnings are reported 3 months after the track was first sold or
          streamed. You can withdraw your account balance as soon as it reaches
          the treshold of € 25.00.
        </div>
      </section>
      <div className="my-money-section ">
        <Tabs value={value} onChange={handleChange} indicatorColor="primary">
          <Tab label="MY BALANCE" {...a11yProps(0)} />
          <Tab label="TRANSACTIONS" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <MyBalance
            userEarnings={groupedEarningsArray}
            withdrawalAmount={withdrawalAmount}
            totalWithdrawalAmount={totalWithdrawalAmount}
            isPayoutEnabled={isPayoutEnabled}
            handleOpenPayoutModal={handleOpenPayoutModal}
            totalReported={totalReported}
            pendingAmount={pendingAmount}
            handlePeriodClick={handlePeriodClick}
            loading={loading}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TransactionHistory
            selectedPeriodId={selectedPeriodId}
            setSelectedPeriodId={setSelectedPeriodId}
          />
        </TabPanel>
      </div>
    </main>
  );
}

export default MyMoney;
